
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5c1.749 0 2.939 1.329 3.719 2.438.104.148.189.293.281.438.092-.145.177-.289.281-.438C17.06 6.33 18.251 5 20 5c1.645 0 3 1.355 3 3 0 .353-.073.684-.188 1H28v6h-1v13H5V15H4V9h5.188A2.925 2.925 0 019 8c0-1.645 1.355-3 3-3zm0 2c-.565 0-1 .435-1 1s.435 1 1 1h2.313c-.121-.206-.097-.22-.25-.438-.627-.892-1.436-1.563-2.063-1.563zm8 0c-.626 0-1.436.671-2.063 1.563-.153.217-.129.232-.25.438H20c.565 0 1-.435 1-1s-.435-1-1-1zM6 11v2h9v-1h2v1h9v-2H6zm1 4v11h8V16h2v10h8V15H7z"}})])
          )
        }
      }
    